// components
import GridPageAbstract from '../GridPageAbstract';
import { ArrangeSquare2BulkIcon } from '../../icons-lib/bulkIcons';
import config from '../../config';

export default class PayoutAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'payoutAccounts';
        this.Server = this.props.context.getState().server.payoutAccounts;

        this.headerStartIcon = ArrangeSquare2BulkIcon;

        this.searchFields = [
            'name',
            'beneficiaryName',
            'beneficiaryIban',
            'addressCountry',
            'addressCity',
            'addressZip',
            'addressStreet',
            'wallets.walletNumber'
        ];

        this.hiddenColumns = config?.hiddenColumns?.payoutAccounts || [];

        this.Head = [
            {
                id: 'wallets',
                key: 'walletNumber',
                label: 'wallets',
                from: 'wallets',
                alignRight: false,
                type: 'walletArray',
                cell: 'WalletArray',
                multiple: true,
                primary: 'walletNumber',
                secondary: 'location.email',
                display: 'walletNumber',
                filterCell: 'Context',
                filterBy: 'wallets',
                filterField: 'wallets.walletNumber',
                filterKey: 'walletNumber',
                searchType: 'server',
                searchFields: ['walletNumber', 'location.email'],
                searchController: 'wallets'
            },
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'beneficiaryName',
                label: 'beneficiaryName',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'beneficiaryIban',
                label: 'beneficiaryIban',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'payoutNotes',
                label: 'payoutNotes',
                alignRight: false,
                cell: 'Text'
            },

            {
                id: 'addressBuildingNumber',
                label: 'addressBuildingNumber',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressStreet',
                label: 'addressStreet',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressZip',
                label: 'addressZip',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressCity',
                label: 'addressCity',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'addressCountry',
                label: 'addressCountry',
                alignRight: false,
                cell: 'Entity',
                filterCell: 'Items',
                filterBy: 'addressCountry',
                items: config.countries
            },
            {
                id: 'chargeBearer',
                label: 'chargeBearer',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            // {
            //     id: 'bankClearingNumber',
            //     label: 'bankClearingNumber',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'bicOrBei',
            //     label: 'bicOrBei',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'instructionPriority',
            //     label: 'instructionPriority',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'serviceLevelType',
            //     label: 'serviceLevelType',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            // {
            //     id: 'serviceLevelValue',
            //     label: 'serviceLevelValue',
            //     alignRight: false,
            //     cell: 'Text'
            // },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((it) => !this.hiddenColumns.includes(it.id));}
}
